module.exports = __webpack_public_path__ + "static/media/sona-buvelle-win.280a1e56.png";